exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selWidth[data-v-2378de10]{width:190px}.range-text[data-v-2378de10]{line-height:22px;white-space:pre-line}.assign-table[data-v-2378de10]{width:420px}.assign-add[data-v-2378de10]{width:420px;line-height:28px;text-align:center;border:1px solid #ebeef5;border-top:0}.danger-text[data-v-2378de10]{color:#f56c6c}", ""]);

// exports
